import { useCustom } from "@refinedev/core";
import { useSearchParams } from "react-router-dom";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";

type CountResponse = {
  totalCount: number;
  requiresActionCount: number;
  toBePurchasedCount: number;
  delayedPurchaseCount: number;
};

export const useOrderCounts = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") ?? "active";

  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const { data, isLoading } = useCustom<CountResponse>({
    url: `store/${selectedCountry?.id}/order/count`,
    method: "get",
    queryOptions: {
      enabled: !!selectedCountry,
      // "data" & "default" are refine keys and they are required for invalidate hook to work
      // tabParam is used to invalidate the query when the tab changes
      queryKey: ["data", "default", tabParam, selectedCountry?.id],
    },
  });

  const counts = {
    all: data?.data?.totalCount ?? 0,
    requiresAction: data?.data?.requiresActionCount ?? 0,
    toBePurchased: data?.data?.toBePurchasedCount ?? 0,
    delayedPurchase: data?.data?.delayedPurchaseCount ?? 0,
  };
  return { counts, loading: isLoading };
};
